module.exports = function promiseDelay(timeoutMs) {
  return new Promise(resolve => setTimeout(resolve, timeoutMs));
};



// WEBPACK FOOTER //
// ./src/js/helpers/promiseDelay.js